/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{ReadDepth as e}from"../output/ReadDepth.glsl.js";import{glsl as t}from"../../shaderModules/interfaces.js";import{Texture2DPassUniform as r}from"../../shaderModules/Texture2DPassUniform.js";function a(a,o){if(!o.multipassEnabled)return;a.fragment.include(e),a.fragment.uniforms.add(new r("terrainDepthTexture",((e,t)=>t.multipassTerrain.depth?.attachment)));const n=o.occlusionPass;a.fragment.code.add(t`
   ${n?"bool":"void"} terrainDepthTest(float fragmentDepth) {
      float depth = texelFetch(terrainDepthTexture, ivec2(gl_FragCoord.xy), 0).r;
      float linearDepth = linearizeDepth(depth);
      ${n?t`return fragmentDepth < linearDepth && depth < 1.0;`:t`
          if(fragmentDepth ${o.cullAboveGround?">":"<="} linearDepth){
            discard;
          }`}
    }`)}class o{constructor(){this.cullAboveGround=!1}}export{o as MultipassTerrainUniforms,a as multipassTerrainTest};
